module.exports = {
      id: "Close-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Close-usage",
      toString: function () {
        return this.url;
      }
    }